import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import _ from 'lodash';
import { nameof } from 'src/app/helper/nameof';
import { AppointmentEntryRemoteDto } from 'src/generated/signalR/appointment-entry-remote-dto';
import { AppointmentsUpdated } from './appointments.actions';

export interface AppointmentsStateModel {
   appointments: { [org00Id: number]: AppointmentEntryRemoteDto[] };
}
@State<AppointmentsStateModel>({
   name: 'appointments',
   defaults: {
      appointments: {},
   },
})
@Injectable()
export class AppointmentsState {
   @Selector([AppointmentsState])
   public static getAppointmentsForDirectoryEntry(state: AppointmentsStateModel) {
      return (orgId: number) => {
         return state.appointments[orgId] ?? [];
      };
   }

   @Action(AppointmentsUpdated)
   @ImmutableContext()
   public appointmentsUpdated(ctx: StateContext<AppointmentsStateModel>, action: AppointmentsUpdated) {
      ctx.setState((state) => {
         const newAppointments = state.appointments;

         _.forEach(action.data.appointments, (appointmentsOfDirectoryEntry, id) => {
            const org00Id = parseInt(id, 10);
            const knownAppointmentsOfDirectoryEntry = state.appointments[org00Id] ?? [];

            _.forEach(appointmentsOfDirectoryEntry.appointments, (appointment) => {
               const appointmentIndex = knownAppointmentsOfDirectoryEntry.findIndex((element) => element.id === appointment.id);
               // a "null" comment, means the appointment has to be removed
               if (_.isNil(appointment.comment)) {
                  if (appointmentIndex !== -1) {
                     knownAppointmentsOfDirectoryEntry.splice(appointmentIndex, 1);
                  }
                  return;
               }

               // add new appointment
               if (appointmentIndex === -1) {
                  knownAppointmentsOfDirectoryEntry.push(appointment);
                  return;
               }

               // update existing one
               knownAppointmentsOfDirectoryEntry[appointmentIndex] = appointment;
            });

            newAppointments[org00Id] = _.orderBy(knownAppointmentsOfDirectoryEntry, [nameof<AppointmentEntryRemoteDto>('start')], ['asc']);
         });

         return state;
      });
   }
}
